import { z } from 'zod';

import { generateMock } from '../../../../../../../utils/generate-mock';

import {
  mileageUnitSchema,
  minMaxSchema,
  vehicleDetailsSchema,
} from './SharedSchema';

const valuationSchema = z.object({
  valuation: z.number(),
  expectedDealerOfferRange: minMaxSchema,
  privateMarketOfferRange: minMaxSchema,
  vehicleDetails: vehicleDetailsSchema,
});

const userVehicleSchema = z
  .object({
    valuationDetails: valuationSchema,
    valuationDate: z.string(),
  })
  .nullable();

const mockUserVehicleData = generateMock(userVehicleSchema.unwrap(), {
  valuationDetails: {
    valuation: 5256,
    expectedDealerOfferRange: {
      min: 3942,
      max: 4468,
    },
    privateMarketOfferRange: {
      min: 4994,
      max: 5256,
    },
    vehicleDetails: {
      bodyType: 'Saloon',
      colour: 'Black',
      engineCapacityInCc: 1896,
      fuelType: 'Diesel',
      make: 'Volkswagen',
      model: 'Passat',
      noOfOwners: 4,
      registrationNumber: '10D324',
      transmission: 'Manual',
      yearOfManufacture: '2010',
      mileage: 1000,
      mileageUnit: mileageUnitSchema.enum.Kilometres,
    },
  },
  valuationDate: 'March 13, 2025',
});

export { userVehicleSchema, mockUserVehicleData, mileageUnitSchema };

export type UserVehicle = z.infer<typeof userVehicleSchema>;
